import { AccountBankingInfo } from "../../graphql/graphql_banking/legder/types/AccountBankingInfo";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import { setAllAccount } from "../../redux/ledger/ledgerSlice";
import { addOrUpdateObject, removeObject } from "../../utils/utils";

export const useCreateOrUpdateAccountCache = () => {
  const dispatch = useAppDispatch();
  const { allAccount } = useAppSelector((state) => state.ledger);

  const updateOrCreate = (account: AccountBankingInfo) => {
    // update list ledger
    const { closedAt, id } = account;
    let newList = allAccount;
    if (closedAt && closedAt != "" && closedAt != "null") {
      newList = removeObject(allAccount, { id });
    } else {
      newList = addOrUpdateObject(allAccount, account);
    }
    dispatch(setAllAccount([...newList]));
  };

  return { updateOrCreate };
};
